import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Match',
  favIconName: 'favicon-match',
  name: 'surprisedcorgi',
  facebookUrl: '/cp/social/r/facebook.html?lid=4',
  instagramUrl: '/cp/social/r/instagram.html?lid=4',
  twitterUrl: '/cp/social/r/twitter.html?lid=4',
  successSiteUrl: 'http://success.match.com/index.aspx?lid=4',
  blogUrl: '/cp/social/r/officialblog.html?lid=4',
  securityEmail: 'security@match.com',
};

export default branding;
